import FirebaseContext, { withFirebase } from "./context";
import Firebase from "./firebase";

export default Firebase;

export { withFirebase, FirebaseContext };



// WEBPACK FOOTER //
// ./src/Firebase/index.ts